module.exports = {"heb":{"bodies":"[\"אני\",\"אנחנו\",\"אתה\",\"את\",\"אתם\",\"הוא\",\"היא\",\"הם\"]","times":"[\"עבר\",\"הווה\",\"שם פועל\",\"ציווי\"]","groupNames":"[\"יחיד\",\"יחידה\",\"רבים\",\"רבות\"]","belongs":"[\"ללא שיוך\",\"שלי\",\"שלך(ז)\",\"שלך(נ)\",\"שלו\",\"שלה\",\"שלנו\",\"שלכם\",\"שלהם\"]"},"en":{"bodies":"[\"I\",\"we\",\"you\",\"him\",\"her\",\"they\"]","times":"[\"past\",\"pressent\",\"שם פועל\",\"ציווי\"]","groupNames":"[\"יחיד\",\"יחידה\",\"רבים\",\"רבות\"]","belongs":"[\"no belong\",\"mine\",\"his\",\"hers\",\"ours\",\"yours\",\"theres\"]"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/data.json
// module id = 380
// module chunks = 0 5